export default __webpack_public_path__ + "static/media/elemento07_web.97970bd4.png";